import React from 'react'
import ReactDOM from 'react-dom'
import { createStore } from './createStore'
import { Provider } from 'shared/components/Provider'
import {InjectReducerManager , injectReducer} from './reducer'
// ========================================================
// Render Setup
// ========================================================
let MOUNT_NODE;

export function render(http, reducer, initialState = {}, routeCreator) {
  const store = createStore(http, reducer, initialState)
  MOUNT_NODE = document.getElementById('root');
  // 注入store
  InjectReducerManager.with(store);
  ReactDOM.render(
    <Provider store={store} routes={routeCreator(store)} />,
    MOUNT_NODE
  )
}

// __DEV__ = true;
if (__DEVELOPMENT__) {
  if (module.hot) {
    // Development render functions
    const renderApp = render
    const renderError = (error) => {
      const RedBox = require('redbox-react').default

      ReactDOM.render(<RedBox error={error} />, MOUNT_NODE)
    }

    // Wrap render in try/catch
    render = (...args) => {
      try {
        renderApp(...args)
      } catch (error) {
        console.error(error)
        renderError(error)
      }
    }

    // Setup hot module replacement
    //module.hot.accept('routes', () =>
    //  setImmediate(() => {
    //    ReactDOM.unmountComponentAtNode(MOUNT_NODE)
    //    render()
    //  })
    //)
  }
}



// WEBPACK FOOTER //
// ../~/shared/src/utils/redux/render.js